<script setup lang="ts">
defineProps<{
  projectColor?: string;
}>();
</script>

<template>
  <div class="">
    <div class="d-flex align-items-center gap-2 pb-2">
      <slot name="top-left"></slot>
      <div class="flex-grow-1"></div>
      <slot name="top-right"></slot>
    </div>
    <div class="mt-2 mb-4">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.shadow-project {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.113);
}
</style>
